/** Line chart with max-min threshold markers*/

<template>
  <div>
    <div :id="zId" />
    <div class="controls">
      <vs-checkbox v-model="showEditLimits" :color="secondaryColor"
        >Edit limits?</vs-checkbox
      >
      <section v-show="showEditLimits">
        <vs-input
          id="graphMax"
          v-model="max"
          class="graph-inputs"
          size="small"
        />-
        <vs-input
          id="graphMin"
          v-model="min"
          class="graph-inputs"
          size="small"
        />
      </section>
      <vs-checkbox v-model="showEditThresholds" :color="secondaryColor"
        >Show thresholds?</vs-checkbox
      >
      <section v-show="showEditThresholds">
        <vs-input
          id="thresholdMax"
          v-model="thresholdMax"
          class="graph-inputs"
          size="small"
        />
        -
        <vs-input
          id="thresholdMin"
          v-model="thresholdMin"
          class="graph-inputs"
          size="small"
        />
      </section>
    </div>
  </div>
</template>
<script>
import "zingchart/zingchart.min";
export default {
  props: {
    zId: {
      type: String,
      default: () => {
        return "zingchart-autoId-" + Math.ceil(Math.random() * 1000000);
      }
    },
    // eslint-disable-next-line
		zHeight: {},
    // eslint-disable-next-line
		zWidth: {},
    zTitle: {
      type: String,
      required: true
    },
    zSubtitle: {
      type: String,
      required: false,
      default: ""
    },
    zDataThreshold: {
      type: Object, // {max:30,min:10}
      required: false,
      default() {
        return null;
      }
    },
    zDataSerie: {
      type: Array, // [[date(in unix milliseconds timestamp),value],...]
      required: true
    },
    zVariableInfo: {
      type: Object, // {alias:'',units:''}
      required: true
    },
    zDataSource: {
      type: Object,
      required: false,
      default: () => {
        return {
          name: "-",
          link: "#"
        };
      }
    }
  },
  data() {
    return {
      secondaryColor: "#19535F",
      width: this.zWidth || "100%",
      height: this.zHeight || 450,
      showEditLimits: false,
      showEditThresholds: false,
      max: 0,
      min: 0,
      thresholdMax: 0,
      thresholdMin: 0
    };
  },
  computed: {
    isDefinedThreshold() {
      return this.zDataThreshold !== null;
      // return Object.keys(this.zDataThreshold).length > 0;
    },
    limits() {
      return { max: this.max, min: this.min };
    },
    thresholds() {
      return {
        max: this.thresholdMax,
        min: this.thresholdMin
      };
    }
  },
  watch: {
    zDataSerie: function() {
      zingchart.exec(this.zId, "destroy");
      this.init();
    },
    limits: function() {
      this.loadChart(); // reload chart on limits change
    },
    thresholds: function() {
      this.loadChart();
    },
    showEditThresholds() {
      this.loadChart();
    }
  },
  mounted() {
    this.init();
  },
  destroyed() {
    zingchart.exec(this.zId, "destroy");
  },
  methods: {
    init() {
      if (this.isDefinedThreshold) {
        this.showEditThresholds = true;
        this.thresholdMax = this.zDataThreshold.max;
        this.thresholdMin = this.zDataThreshold.min;
      }
      this.setDefaultChartLimits();
      this.loadChart();
    },
    loadChart() {
      const chart = this.createChart();
      zingchart.render(chart);
    },
    createChart() {
      const chart = this.configChart();
      return {
        id: this.zId,
        width: this.width,
        height: this.height,
        data: chart,
        hideprogresslogo: true
      };
    },
    configChart() {
      const series = this.getDataSeries();
      const markersThreshold = this.getMarkers();
      const chartConfig = {
        type: "line",
        utc: true,
        backgroundColor: "transparent",
        title: {
          fontSize: "14px",
          color: "#19535F",
          fontWeight: "normal",
          text: this.zTitle
        },
        subtitle: {
          text: this.zSubtitle,
          color: "#98c5d1",
          fontStyle: "italic",
          fontSize: 11
        },
        source: {
          text: `Source: ${this.zDataSource.name}`,
          fontWeight: "bold",
          textAlign: "left",
          x: 50,
          color: "#2D2D2D"
        },
        plot: {
          "data-min": this.showEditThresholds ? this.thresholdMin : "-",
          "data-max": this.showEditThresholds ? this.thresholdMax : "-",
          tooltip: {
            visible: false
          }
        },
        scaleY: {
          format: `%v ${this.zVariableInfo.units}`,
          values: `${this.limits.min}:${this.limits.max}:1`, // '0:40:1',
          item: {
            fontSize: "11"
          },
          // label: {
          //   fontWeight: 'none',
          //   text: 'Degrees (Celsius)'
          // },
          markers: markersThreshold
        },
        scaleX: {
          item: {
            fontSize: "11"
          },
          transform: {
            type: "date",
            all: "%d/%m/%y %hh"
          },
          zooming: true
        },
        preview: {
          height: "10%",
          // x: '5%',
          // width: '95%',
          y: "82%"
        },
        crosshairX: {
          scaleLabel: {
            backgroundColor: "#7CB5EC"
          },
          plotLabel: {
            backgroundColor: "white",
            multiple: false,
            borderRadius: 3,
            text: `<span style='color:#7CB5EC;font-weight:bold;'>Value</span>: %v ${
              this.zVariableInfo.units
            }\n<span style='color:#7CB5EC;font-weight:bold;'>Threshold</span>: %data-min ${
              this.zVariableInfo.units
            } | %data-max ${this.zVariableInfo.units}`
          }
        },
        series: series
      };
      return chartConfig;
    },
    setDefaultChartLimits() {
      const values = this.zDataSerie.map(data => {
        return data[1];
      });
      let min = parseInt(Math.min(...values));
      let max = parseInt(Math.max(...values));
      min =
        this.isDefinedThreshold && this.zDataThreshold.min < min
          ? this.zDataThreshold.min - 2
          : min - 2;
      max =
        this.isDefinedThreshold && this.zDataThreshold.max > max
          ? this.zDataThreshold.max + 2
          : max + 2;

      this.max = max;
      this.min = min;
    },
    getMarkers() {
      if (!this.showEditThresholds) return [];
      return [
        {
          type: "line",
          range: [this.thresholds.min],
          lineColor: "#EDAE49",
          lineWidth: 1,
          label: {
            text: "Min",
            backgroundColor: "transparent",
            textAlpha: 0.7,
            fontSize: 9,
            offsetX: 10,
            offsetY: 15
          }
        },
        {
          type: "line",
          range: [this.thresholds.max],
          lineColor: "#FB3640",
          lineWidth: 1,
          label: {
            text: "Max",
            backgroundColor: "transparent",
            textAlpha: 0.7,
            fontSize: 9,
            offsetX: 10,
            offsetY: -2
          }
        }
      ];
    },
    getDataSeries() {
      /* Return Data Series */
      return [
        {
          type: "line",
          values: this.zDataSerie,
          lineWidth: 2,
          shadow: false,
          lineColor: "#7CB5EC",
          marker: {
            size: 3,
            backgroundColor: "white",
            borderColor: "#7CB5EC",
            shadow: false
          }
        }
      ];
    }
  }
};
</script>
<style lang="scss" scoped>
.graph-inputs {
  width: 120px;
}
.controls {
  display: flex;
  justify-content: space-evenly;
  margin-top: 1rem;
  font-size: 0.8rem;
  font-family: $app-font;
}
</style>
